import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BankVerificationModelPage } from './bank-verification-model.page';

const routes: Routes = [
  {
    path: '',
    component: BankVerificationModelPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BankVerificationModelPageRoutingModule {}
